import { render, staticRenderFns } from "./ImageView.vue?vue&type=template&id=ca3ea2f2&scoped=true&"
import script from "./ImageView.vue?vue&type=script&lang=js&"
export * from "./ImageView.vue?vue&type=script&lang=js&"
import style0 from "./ImageView.vue?vue&type=style&index=0&id=ca3ea2f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca3ea2f2",
  null
  
)

export default component.exports